export const REPORT_LINKS = [
  {
    title: 'reports.drug_report.title',
    url: '/reports/drug-report',
  },
];
